<template>
  <div class="chat-bubble">
    <span class="bubble-label">CHAT</span>
    <img
      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjM0MzggOUwxNy4wMzEyIDQuMzEyNUMxNy42NDA2IDMuNzUgMTcuNjQwNiAyLjgxMjUgMTcuMDMxMiAyLjI1TDE2IDEuMjE4NzVDMTUuNDM3NSAwLjYwOTM3NSAxNC41IDAuNjA5Mzc1IDEzLjkzNzUgMS4yMTg3NUw5LjI1IDUuOTA2MjVMNC41MTU2MiAxLjIxODc1QzMuOTUzMTIgMC42MDkzNzUgMy4wMTU2MiAwLjYwOTM3NSAyLjQ1MzEyIDEuMjE4NzVMMS40MjE4OCAyLjI1QzAuODEyNSAyLjgxMjUgMC44MTI1IDMuNzUgMS40MjE4OCA0LjMxMjVMNi4xMDkzOCA5TDEuNDIxODggMTMuNzM0NEMwLjgxMjUgMTQuMjk2OSAwLjgxMjUgMTUuMjM0NCAxLjQyMTg4IDE1Ljc5NjlMMi40NTMxMiAxNi44MjgxQzMuMDE1NjIgMTcuNDM3NSAzLjk1MzEyIDE3LjQzNzUgNC41MTU2MiAxNi44MjgxTDkuMjUgMTIuMTQwNkwxMy45Mzc1IDE2LjgyODFDMTQuNSAxNy40Mzc1IDE1LjQzNzUgMTcuNDM3NSAxNiAxNi44MjgxTDE3LjAzMTIgMTUuNzk2OUMxNy42NDA2IDE1LjIzNDQgMTcuNjQwNiAxNC4yOTY5IDE3LjAzMTIgMTMuNzM0NEwxMi4zNDM4IDlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
      alt="default"
      class="chat-launch-icon"
      v-if="chatWindowMaximized"
    />
    <img
      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjM3NSA3LjVDMTguMzc1IDMuNzE4NzUgMTQuMzM1OSAwLjYyNSA5LjQzNzUgMC42MjVDNC40OTYwOSAwLjYyNSAwLjUgMy43MTg3NSAwLjUgNy41QzAuNSA5LjAwMzkxIDEuMTAxNTYgMTAuMzM1OSAyLjEzMjgxIDExLjQ1MzFDMS41MzEyNSAxMi43ODUyIDAuNTg1OTM4IDEzLjgxNjQgMC41ODU5MzggMTMuODE2NEMwLjUgMTMuOTAyMyAwLjQ1NzAzMSAxNC4wNzQyIDAuNSAxNC4yMDMxQzAuNTg1OTM4IDE0LjMzMiAwLjY3MTg3NSAxNC4zNzUgMC44NDM3NSAxNC4zNzVDMi4zOTA2MiAxNC4zNzUgMy42Nzk2OSAxMy44NTk0IDQuNjI1IDEzLjMwMDhDNiAxMy45ODgzIDcuNjc1NzggMTQuMzc1IDkuNDM3NSAxNC4zNzVDMTQuMzM1OSAxNC4zNzUgMTguMzc1IDExLjMyNDIgMTguMzc1IDcuNVpNMjMuNjE3MiAxNi45NTMxQzI0LjYwNTUgMTUuODM1OSAyNS4yNSAxNC41MDM5IDI1LjI1IDEzQzI1LjI1IDEwLjE2NDEgMjIuOTI5NyA3LjY3MTg4IDE5LjY2NDEgNi42NDA2MkMxOS43MDcgNi45NDE0MSAxOS43NSA3LjI0MjE5IDE5Ljc1IDcuNUMxOS43NSAxMi4wNTQ3IDE1LjEwOTQgMTUuNzUgOS40Mzc1IDE1Ljc1QzguOTY0ODQgMTUuNzUgOC40OTIxOSAxNS43NSA4LjA2MjUgMTUuNzA3QzkuMzk0NTMgMTguMTU2MiAxMi41NzQyIDE5Ljg3NSAxNi4zMTI1IDE5Ljg3NUMxOC4wNzQyIDE5Ljg3NSAxOS43MDcgMTkuNDg4MyAyMS4wODIgMTguODAwOEMyMi4wMjczIDE5LjM1OTQgMjMuMzE2NCAxOS44NzUgMjQuOTA2MiAxOS44NzVDMjUuMDM1MiAxOS44NzUgMjUuMTY0MSAxOS44MzIgMjUuMjA3IDE5LjcwMzFDMjUuMjUgMTkuNTc0MiAyNS4yNSAxOS40MDIzIDI1LjEyMTEgMTkuMzE2NEMyNS4xMjExIDE5LjMxNjQgMjQuMTc1OCAxOC4yODUyIDIzLjYxNzIgMTYuOTUzMVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="
      alt="default"
      class="chat-launch-icon"
      v-else
    />
  </div>
</template>

<script>
export default {
  props: {
    chatWindowMaximized: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.chat-bubble {
  font-family: 'Open Sans';
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-position: 50%;
  -webkit-box-shadow: none;
  box-shadow: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.bubble-label {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
}

.chat-launch-icon {
  width: 27px;
  height: 21px;
}
</style>
